'use client';
import CDNImage from '@/components/cdnImage/cdnImage';
import UKDrawer from '@/components/UKDrawer';
import { HelpDetailWrapper } from '@/styles/product';
import { useEffect, useRef, useState } from 'react';
import style from './style.module.scss';

// ---------------引入埋点------------------
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/30451';

export default function Module({ moduleData }: { moduleData: any }) {
  const [index, setIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  const animationRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let timer = null;
    // 3个元素及以上，说明右侧有2个以上的元素，才需要动画
    if (
      moduleData.externalData &&
      moduleData.externalData.data &&
      moduleData.externalData.data.length > 2
    ) {
      timer = setInterval(() => {
        if (index < moduleData.externalData.data.length - 1) {
          setIndex((preIndex) => preIndex + 1);
          // 滑动到最后一个用于占位的元素，去掉动画，跳回到第一个元素
          if (index === moduleData.externalData.data.length - 2) {
            setTimeout(() => {
              setIndex(0);
            }, 1000);
          }
        } else {
          setIndex(0);
        }
      }, 4000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [index]);

  const mentalCardRender = (data: any, index?: number) => {
    return (
      <div
        className={style['card']}
        key={index}
        exptag={'exp|' + EXPOSURE_RECORD.Home_Platform_Mind_Expo}
        data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
        data-exptag-json-param={JSON.stringify({ title: data.serviceTitle })}
        onClick={() => handleOpenServiceDialog(data)}
      >
        <CDNImage src={data.icon} width={20} height={20} alt='' />
        <div className={style['content']}>
          <div className={style['serviceTitle']}>{data.serviceTitle}</div>
          <div className={style['serviceSubTitle']}>{data.serviceSubTitle}</div>
        </div>
      </div>
    );
  };

  if (
    !moduleData.externalData ||
    !moduleData.externalData.data ||
    moduleData.externalData.data.length < 2
  ) {
    return null;
  }

  const handleOpenServiceDialog = (data: any) => {
    setIsOpen(true);
    setTitle(data.serviceTitle);
    setContent(data.serviceContent);
    // @ts-ignore:next-line
    sendClickTrack.Home_Platform_Mind({ title: data.serviceTitle });
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const draperProps = {
    title,
    openDrawer: isOpen,
    height: '100%',
    setOpenDrawer: setIsOpen,
    handleClose,
    draperSx: {
      height: '62.3%',
    },
  };
  return (
    <div className={style['uk-h5-mental']}>
      <div className={style['container']}>{mentalCardRender(moduleData.externalData.data[0])}</div>
      <div className={style['container']}>
        <div
          style={{
            transition: index === 0 ? 'none' : 'transform 0.5s linear',
            transform: `translateY(-${index * 40}px)`,
          }}
          ref={animationRef}
        >
          {moduleData.externalData.data.slice(1).map((item: any, index: number) => {
            return mentalCardRender(item, index);
          })}

          {/*无限滚动占位元素*/}
          {mentalCardRender(moduleData.externalData.data[1])}
        </div>
      </div>
      <UKDrawer {...draperProps}>
        <HelpDetailWrapper dangerouslySetInnerHTML={{ __html: content }} />
      </UKDrawer>
    </div>
  );
}
